var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarineIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0205 11.5H13.0205C12.4205 11.5 12.0205 11.9 12.0205 12.5C12.0205 13.1 12.4205 13.5 13.0205 13.5H13.9205C13.5205 16 11.5205 18 9.02051 18.4V9.5H10.0205C10.6205 9.5 11.0205 9.1 11.0205 8.5C11.0205 7.9 10.6205 7.5 10.0205 7.5H9.02051V6.3C10.2205 5.9 11.0205 4.8 11.0205 3.5C11.0205 1.8 9.72051 0.5 8.02051 0.5C6.32051 0.5 5.02051 1.8 5.02051 3.5C5.02051 4.8 5.82051 5.9 7.02051 6.3V7.5H6.02051C5.42051 7.5 5.02051 7.9 5.02051 8.5C5.02051 9.1 5.42051 9.5 6.02051 9.5H7.02051V18.4C4.52051 18 2.52051 16 2.12051 13.5H3.02051C3.62051 13.5 4.02051 13.1 4.02051 12.5C4.02051 11.9 3.62051 11.5 3.02051 11.5H1.02051C0.420508 11.5 0.0205078 11.9 0.0205078 12.5C0.0205078 16.9 3.62051 20.5 8.02051 20.5C12.4205 20.5 16.0205 16.9 16.0205 12.5C16.0205 11.9 15.6205 11.5 15.0205 11.5ZM8.02051 2.5C8.62051 2.5 9.02051 2.9 9.02051 3.5C9.02051 4.1 8.62051 4.5 8.02051 4.5C7.42051 4.5 7.02051 4.1 7.02051 3.5C7.02051 2.9 7.42051 2.5 8.02051 2.5Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineIcon);
export default __webpack_public_path__ + "static/media/marine-icon.c73e746c362f1c3c356810887d36e5d9.svg";
export { ForwardRef as ReactComponent };